var parent = require('../../es/instance/filter');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/filter.js
// module id = 1111
// module chunks = 0